var React = require('react');

function AlertCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M22.998 11.81c.105 6.074-4.923 11.085-10.998 11.192-6.075.104-10.893-4.735-10.998-10.81C.896 6.12 5.925 1.106 12 1.002c6.074-.107 10.892 4.734 10.998 10.807zM12 13V6","key":0}),React.createElement("path",{"stroke":"#737680","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12.5 17c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-.277.223-.5.5-.5.276 0 .5.223.5.5z","key":1})]);
}

AlertCircle.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = AlertCircle;

AlertCircle.default = AlertCircle;
